export default "/assets/empty_frame-7fa76d8b2fcd64e0bed3bce385cab7a19d89b5b90d0288087e26b5fd19a1b58c.svg";